const selectList ={
    2: [
      {
        name: '大三',
        value: 1,
        checked:false
      },
      {
        name: '应届',
        value: 2,
        checked:false,
      },
      {
        name: '二战',
        value: 3,
        checked:false,
      },
      {
        name: '三战',
        value: 4,
        checked:false,
      },
      {
        name: '在职',
        value: 5,
        checked:false,
      },
      {
        name: '脱产',
        value: 6,
        checked:false,
      },
    ],
    4: [
      {
        name: '基础已过完一轮及以上',
        value: 1,
        checked:false,
      },
      {
        name: '基础知识未过完一轮',
        value: 2,
        checked:false,
      },
      {
        name: '只看了一下、未系统开始学',
        value: 3,
        checked:false,
      },
    ],
    5: [
      {
        name: '单词已过完两轮以上，语法及长难句已系统学完一轮',
        value: 1,
        checked:false,
      },
      {
        name: '单词已过完一轮，语法长难句过完一轮、单词未系统过，语法及长难句已系统学完一轮',
        value: 2,
        checked:false,
      },
      {
        name: '只是看一下，未系统开始学',
        value: 3,
        checked:false,
      },
    ],
    6: [
      {
        name: '已启动',
        value: 1,
        checked:false,
      },
      {
        name: '未启动',
        value: 0,
        checked:false,
      },
    ],
    7: [
      {
        name: '数学',
        value: 1,
        checked:false,
      },
      {
        name: '英语',
        value: 2,
        checked:false,
      },
      {
        name: '政治',
        value: 3,
        checked:false,
      },
      {
        name: '专业课',
        value: 4,
        checked:false,
      },
    ],
     8: [
      {
        name: '12小时以上',
        value: 1,
        checked:false,
      },
      {
        name: '10小时以上',
        value: 2,
        checked:false,
      },
      {
        name: '8小时以上',
        value: 3,
        checked:false,
      },
      {
        name: '不足8小时',
        value: 4,
        checked:false,
      },
    ],
  };
  export default selectList;
  